export default {
  title: 'Data deletion requests',
  fields: {
    created_at: 'Requested at',
    restaurant: 'Restaurant',
    customer: 'Customer',
    note: 'Note',
    status: 'Status',
    completed_by: 'Completed by',
    actions: 'Actions',
  },
  statuses: {
    pending: 'Pending',
    completed: 'Completed',
  },
  buttons: {
    approve: 'Approve',
  },
  modals: {
    approve: {
      title: 'Approve data deletion for {{name}}?',
      description:
        'This permanently deletes the customer’s personal data and cannot be undone. The request will be marked as completed.',
    },
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    failed_to_approve: 'Failed to approve request',
    approved: 'Request approved and data deleted',
  },
};
